import { ApiFieldValueTypes, CustomFieldInformation } from "@/types/custom-field.types.ts";
import { Radio, Stack } from "@skailer-com/uikit";
import { Fragment } from "react";

interface CustomFieldChoiceTypeStepProps {
  fieldTypeInfo: Record<string, CustomFieldInformation>;
  value?: ApiFieldValueTypes;
  onChange: (value: ApiFieldValueTypes) => void;
}

export function CustomFieldChoiceTypeStep({
  fieldTypeInfo,
  value,
  onChange,
}: CustomFieldChoiceTypeStepProps) {
  return (
    <Stack gap={"sm"}>
      {Object.values(fieldTypeInfo).map((item, index) => (
        <Fragment key={`field_type_${item.type}`}>
          {index > 0 && <hr />}
          <Radio
            checked={item.type === value}
            title={item.title}
            caption={item.description}
            onChange={() => onChange(item.type)}
          />
        </Fragment>
      ))}
    </Stack>
  );
}
